import { useIntl } from "react-intl";
import { Flex } from "@/components/atoms/flex";
import {
	NoInteractionActivePlaceholderIcon,
	NoInteractionWaitingPlaceholderIcon,
} from "@/common/icons";
import { Text } from "@fluentui/react-components";
import { useStyle } from "./style";

export enum PlaceholderType {
	Active,
	Waiting,
	Voicemail,
}

export interface NoInteractionPlaceHolderProps {
	type: PlaceholderType;
}

export const NoInteractionPlaceholder = (
	props: NoInteractionPlaceHolderProps
) => {
	const intl = useIntl();
	const style = useStyle();

	const getIconByType = () => {
		switch (props.type) {
			case PlaceholderType.Active:
				return <NoInteractionActivePlaceholderIcon />;
			case PlaceholderType.Waiting:
				return <NoInteractionWaitingPlaceholderIcon />;
			case PlaceholderType.Voicemail:
				return <NoInteractionWaitingPlaceholderIcon />;
		}
	};

	const getTextByType = () => {
		let message = "";
		switch (props.type) {
			case PlaceholderType.Active:
				message = "NoInteractionActivePlaceholder";
				break;
			case PlaceholderType.Waiting:
				message = "NoInteractionWaitingPlaceholder";
				break;
			case PlaceholderType.Voicemail:
				message = "NoInteractionVoicemailPlaceholder";
		}

		return (
			<Text
				className={style.text}
				children={intl.formatMessage({ id: `Interaction.${message}` })}
			/>
		);
	};

	return (
		<Flex column={true} vAlign="center">
			<div className={style.iconContainer}>{getIconByType()}</div>
			{getTextByType()}
		</Flex>
	);
};
